import { colors } from 'theme'

export const defaultThemeStyles = {
    text: colors.white,
    border: colors.white,
}
